// React
import React from 'react';

// Store
import useSiteStore from "../../../store/siteStore.js";

// Components
import { Box, Stack } from "@mui/material/index.js";
import { EditOutlined, SendOutlined, ArrowBack } from '@mui/icons-material';
import { Button, Divider, Tab, Tabs } from "@mui/material";
import CoachList from "../../custom/CoachList.js";
import ParentList from "../../custom/ParentList.js";
import WeeklyScheduleMobile from "../../custom/WeeklyScheduleMobile.js";
import CreateWeeklyScheduleSessions from '../../custom/CreateWeeklyScheduleSessions.js';
import CustomSnackbar from '../../custom/CustomSnackbar.js';

// Hooks
import { useAppTheme } from '../../../hooks/useAppTheme.js';
// Style
import { blue, grey, green } from "@mui/material/colors/index.js";
import styles from '../Coach/coachHome.module.css';
import { darkTheme } from '../../../styles/colorSchemes/index.js';


const AthleteHomeMobile = (props) => {
    const { addTrainingSession, athlete, coaches, handleChangeTrainingSession, onCloseEditTrainingSession, parents, handleSend, isAbove18, prepCreateWeeklySchedule, startWeek } = props;
    
    // selectedCalenderWeek entfernt
    const { openWeeklySchedule, selectedTab, setSelectedTab, failMessage,
         setSnackbarOpenFail, snackbarOpenFail,
         year } = useSiteStore();
    
    // Theme
    const { isDarkMode } = useAppTheme();

    const handleTabChange = (event, newValue) => {
        if (newValue === 0 || newValue === 1 || newValue === 2) {
            localStorage.removeItem('trainingSessions_athlete');
        }
        setSelectedTab(newValue);
    };

    const tabSx = {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '0.85rem',
        minHeight: 36,
        color: isDarkMode ? darkTheme.textSecondary : grey[700],
        px: 2.5,
        py: 0.75,
        minWidth: 90,
        borderRadius: '18px',
        border: `1.5px solid ${isDarkMode ? darkTheme.divider : grey[300]}`,
        backgroundColor: isDarkMode ? darkTheme.cardBg : 'white',
        transition: 'all 0.3s ease',
        '&:hover': {
            color: isDarkMode ? darkTheme.accent : blue[600],
            borderColor: isDarkMode ? darkTheme.accent : blue[300],
            backgroundColor: isDarkMode ? 'rgba(255, 152, 0, 0.1)' : blue[50],
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
        '&.Mui-selected': {
            color: isDarkMode ? '#000000' : 'white', // SCHWARZ
            backgroundColor: isDarkMode ? darkTheme.accent : blue[600],
            borderColor: isDarkMode ? darkTheme.accent : blue[600],
            fontWeight: 600,
            boxShadow: isDarkMode ? '0 4px 12px rgba(255, 152, 0, 0.3)' : '0 4px 12px rgba(25, 118, 210, 0.3)',
            '&:hover': {
                backgroundColor: isDarkMode ? darkTheme.accentDark : blue[700],
                borderColor: isDarkMode ? darkTheme.accentDark : blue[700],
                color: isDarkMode ? '#000000' : 'white', // SCHWARZ
            }
        }
    };
    
    return (
        <Stack sx={{ ml: '5px', mr: '5px', justifyContent: 'center', alignItems: 'center', minWidth: '0px', width: '1fr' }}>
            {/* Hide tabs when in create training session dialog (selectedTab === 3) */}
            {selectedTab !== 3 && (
                <Box sx={{ display: 'flex', width: '100%', minWidth: '0px', justifyContent: 'center', mt: 1 }}>
                    <Tabs 
                        variant="scrollable" 
                        scrollButtons="auto" 
                        value={ selectedTab } 
                        onChange={ handleTabChange }
                        sx={{ 
                            justifyContent: 'center', 
                            minWidth: '0px',
                            overflow: 'visible',
                            '& .MuiTabs-indicator': { 
                                display: 'none'
                            },
                            '& .MuiTabs-flexContainer': {
                                gap: 0.5,
                            },
                            '& .MuiTabs-scroller': {
                                overflow: 'visible !important',
                            }
                        }}>
                            <Tab 
                                label="Wochenplan"
                                sx={tabSx}
                            />
                            <Tab 
                                label="Trainerteam"
                                sx={tabSx}
                            />
                            <Tab 
                                label="Eltern"
                                sx={tabSx}
                            />
                            <Tab label='Send' sx={{ display: 'none' }}/>
                    </Tabs>
                    <Divider/>
                </Box>
            )}

            { selectedTab === 0 && (
                <>
                    {/* Create Button */}
                    {isAbove18 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 2, mb: 1 }}>
                            <Button
                                variant="contained"
                                startIcon={<EditOutlined />}
                                onClick={() => prepCreateWeeklySchedule()}
                                sx={{
                                    bgcolor: isDarkMode ? darkTheme.accent : blue[600],
                                    color: isDarkMode ? '#000000' : 'white', // SCHWARZ
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    px: 2.5,
                                    py: 1,
                                    borderRadius: 3,
                                    boxShadow: 2,
                                    width: '95%',
                                    fontSize: '0.875rem',
                                    '&:hover': {
                                        bgcolor: isDarkMode ? darkTheme.accentDark : blue[700],
                                        boxShadow: 4
                                    }
                                }}
                            >
                                Trainingseinheit erstellen
                            </Button>
                        </Box>
                    )}

                    <WeeklyScheduleMobile
                        isEditable={false}
                        isFeedbackEditable={true}    
                        onCloseEditTrainingSession={onCloseEditTrainingSession}
                        open={openWeeklySchedule}
                        selectedAthlete={athlete}
                        isDeletable={isAbove18}
                        isAthlete
                    />
                </>
            )}            
            
            { selectedTab === 1 && (
                <Box sx={{ width: '100%' }}>
                    <CoachList search={ "" } coaches={ coaches } showAthleteAmount={ false } isEditable={ false }/>
                </Box>
            )}
            
            { selectedTab === 2 && (
                <Box sx={{ width: '100%' }}>
                    <ParentList search={ "" } parents={ parents }showAthleteAmount={ false } isEditable={ false }/>
                </Box>
            )}

            { selectedTab === 3 && (
                <Box sx={{ width: '100%' }}>
                    {/* Header with Back and Save buttons */}
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        mb: 2, 
                        mt: 1,
                        px: 1,
                        pb: 1,
                        borderBottom: isDarkMode ? `1px solid ${darkTheme.divider}` : `1px solid ${grey[300]}`
                    }}>
                        <Button 
                            variant="outlined" 
                            onClick={() => {
                                setSelectedTab(0);
                                localStorage.removeItem('trainingSessions_athlete');
                            }}
                            startIcon={<ArrowBack />}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                borderColor: isDarkMode ? darkTheme.cardBorder : 'divider',
                                color: isDarkMode ? darkTheme.textPrimary : 'text.primary',
                                px: 2,
                                py: 0.75,
                                borderRadius: 3,
                                '&:hover': {
                                    bgcolor: isDarkMode ? darkTheme.cardHover : grey[100],
                                    borderColor: isDarkMode ? darkTheme.textSecondary : grey[400]
                                }
                            }}
                        >
                            Zurück
                        </Button>
                        <Button 
                            variant="contained" 
                            startIcon={<SendOutlined />} 
                            onClick={handleSend} 
                            sx={{ 
                                bgcolor: green[600], 
                                color: 'white',
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 1.5,
                                py: 0.75,
                                borderRadius: 3,
                                boxShadow: 2,
                                fontSize: '0.8rem',
                                '&:hover': { 
                                    bgcolor: green[700],
                                    boxShadow: 4
                                } 
                            }}
                        >
                            Plan speichern
                        </Button>
                    </Box>

                    {/* Snackbar for errors */}
                    <CustomSnackbar 
                        open={snackbarOpenFail} 
                        onClose={() => setSnackbarOpenFail(false)} 
                        message={failMessage} 
                        severity="error" 
                        autoHideDuration={4000}
                    />

                    {/* Create Sessions Form */}
                    <Box sx={{ height: 'calc(100vh - 200px)', overflow: 'auto', px: 1 }}>
                        <CreateWeeklyScheduleSessions 
                            styles={styles} 
                            startWeek={startWeek} 
                            year={year}
                            handleChangeTrainingSession={handleChangeTrainingSession} 
                            addTrainingSession={addTrainingSession} 
                            isAthlete
                        />
                    </Box>
                </Box>
            )}
        </Stack>
    )
}

export default AthleteHomeMobile;